<template>
  <div class="cashOutAudit">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c jus-b">
      <div>
        <b>{{topTitle.title}}</b>
        <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
        <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
      </div>
      <img @click="goHistoryAudit"
           class="titRiImg"
           src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/history.png' alt=""
      >
    </div>

    <!-- 四大审核信息+按钮 -->
    <ul class="auditInfo">
      <li class="infoLi boxs">
        <div class="info_tit">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo1.png' alt="">
          <span>待审核提现总额（元）</span>
        </div>
        <div class="info_money blackText">{{count_data.pending_total_fee}}</div>
        <div class="info_count">待审核单数: <span>{{count_data.pending_total_count}}</span></div>
      </li>

      <li class="infoLi boxs">
        <div class="info_tit">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo2.png' alt="">
          <span>审核通过金额（元）</span>
        </div>
        <div class="info_money lightGText">{{count_data.pass_total_fee}}</div>
        <div class="info_count">审核通过单数: <span>{{count_data.pass_total_count}}</span></div>
      </li>

      <li class="infoLi boxs">
        <div class="info_tit">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo3.png' alt="">
          <span>拒绝放款金额（元）</span>
        </div>
        <div class="info_money orangeText">{{count_data.reject_total_fee}}</div>
        <div class="info_count">拒绝放款单数: <span>{{count_data.reject_total_count}}</span></div>
      </li>

      <li class="infoLi boxs">
        <div class="info_tit">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/auditInfo4.png' alt="">
          <span>延后处理金额（元）</span>
        </div>
        <div class="info_money grayText">{{count_data.delay_total_fee}}</div>
        <div class="info_count">延后处理单数: <span>{{count_data.delay_total_count}}</span></div>
      </li>

      <!-- 开始审核 -->
      <li v-if="showStartBtn" @click="showMore" class="lastStartBtn boxs">
        <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/startAudit.png' alt="">
      </li>

      <li v-if="!showStartBtn" @click="leaveATime" class="lastLeaveBtn boxs">
        <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/leave.png' alt="">
        <p>离开一下</p>
      </li>
    </ul>

    <!-- 没有可审核的单 -->
    <div class="noOrder boxs" v-if="noOrder">
      <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/noOrder.png' alt="" class="noOrderImg">
      <p>已经没有可审核的单了</p>
    </div>

    <!-- 主要内容 -->
    <div class="mainBox boxs" v-if="!showStartBtn">
      <!-- 主要内容-左边 -->
      <div class="le_main boxs">
        <!-- 左边-上提现信息 -->
        <div class="topPayInfo boxs">
          <div class="firstLine">
            <span class="first_le">提现申请</span>
            <span class="first_ri">交易号：<b>{{wallet_order_info.code}}</b></span>
          </div>
          <div class="secondLine">
            <span class="second_le">用户基本信息</span>
            <span class="second_ri">本次提现信息</span>
          </div>
          <div class="thirdBlock">
            <!-- 左边用户基本信息 -->
            <div class="third_le">
              <div class="thirdLine">
                <b class="line_tit">会员名称</b>
                <span class="line_msg">{{wallet_order_info.create_member_name}}</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">提现方式</b>
                <span class="line_msg">-</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">提现账号</b>
                <span class="line_msg">-</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">账户状态</b>
                <span class="line_msg4">-</span>
              </div>
              <div class="botLine">
                <b class="bot_tit">提现时刻余额 (元)：</b>
                <span class="bot_msg">{{wallet_order_info.balance_of_apply_time}}</span>
              </div>
            </div>
            <!-- 右边本次提现信息 -->
            <div class="third_ri">
              <div class="thirdLine">
                <b class="line_tit">提现时间</b>
                <span class="line_msg">{{wallet_order_info.create_time}}</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">提现方式</b>
                <span class="line_msg">{{wallet_order_info.pay_type}}</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">到账账号</b>
                <span class="line_msg">{{wallet_order_info.payee_account}}</span>
              </div>
              <div class="thirdLine">
                <b class="line_tit">手续费</b>
                <span class="line_msg">{{wallet_order_info.service_fee}}元</span>
              </div>
              <div class="botLine">
                <b class="bot_tit">提现金额 (元)：</b>
                <span class="bot_msg">{{wallet_order_info.fee}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 左边-下表格 -->
        <div class="botTable boxs tableTheadGray">
          <div class="tableTop">
            <span class="top_le">用户收支流水明细表</span>
            <span class="top_ri">本次提现时刻该用户的理论可支配资金为：<b>{{wallet_order_info.balance_of_apply_time}}</b> 元</span>
          </div>
          <el-table :data="tableData"
                    style="width: 100%;"
                    max-height="649"
                    border
                    fit
                    stripe
                    highlight-current-row
                    tooltip-effect="dark"
          >
            <el-table-column label="创建时间" prop="log_time" min-width="160" header-align="center" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="类型" prop="log_type" min-width="70" header-align="center" align="center"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="{lightGText:scope.row.log_type.indexOf('提现') != -1}">
                  {{scope.row.log_type}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="收支" prop="in_or_out" min-width="70" header-align="center" align="center"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="{lightGText:scope.row.in_or_out=='支出'}">
                  {{scope.row.in_or_out}}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="order_status" min-width="60" header-align="center" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="金额（元）" prop="fee" min-width="140" header-align="center" align="right"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="手续费（元）" prop="service_fee" min-width="140" header-align="center" align="right"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="可使用余额（元）" prop="balance" min-width="140" header-align="center" align="right"
                             show-overflow-tooltip></el-table-column>
          </el-table>
          <div class="pageBox boxs">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="searchForm.page" :page-sizes="[10, 20, 30]" :page-size="searchForm.rows"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>

      </div>

      <!-- 主要内容-右边 -->
      <div class="ri_main boxs">
        <img @click="showPassAuditDialog" src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/passAudit.png'
             alt="" class="passImg">
        <div class="msgBox" v-if="wallet_order_info.check_result">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/true.png' alt="" class="leftImg">
          <span class="riMsg">提现时刻余额校验通过</span>
        </div>
        <div class="msgBox redMsg" v-if="!wallet_order_info.check_result">
          <img src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/error.png' alt="" class="leftImg">
          <span class="riMsg">提现时刻余额校验拒绝</span>
        </div>
        <div class="tip1">时刻余额：<span>用户在提现那一刻记录当时余额</span></div>
        <div class="tip2">提现金额：<span>本次提现金额</span></div>
        <div class="tip3">如果<span>【提现金额】</span> ≤ <span>【提现时刻余额】</span></div>
        <div class="tip4">则：<span>校验通过</span></div>
        <div class="botBtnLine">
          <img @click="showRefusalToLendDialog"
               src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/refusalToLend.png' alt="" class="botLeImg">
          <img @click="showDelayHandleDialog"
               src='@/assets/images/busy/Finance/FinancialAudit/CashOutAudit/delayHandle.png' alt="" class="botRiImg">
        </div>
      </div>
    </div>


    <!-- 弹窗 -->
    <el-dialog width="440px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="false">
      <el-form ref="form" :rules="rules" :model="processForm" label-width="0px">

        <el-row v-if="dialogTitle == 'passAuditDialogTit'">
          <el-col :span="10">
            <el-form-item prop="payWay">
              <span>{{wallet_order_info.pay_type}}</span>
            </el-form-item>
          </el-col>

          <el-col :span="14">
            <el-form-item prop="cashAccountNum">
              <!-- <el-form-item> -->
              提现账号：<span>{{wallet_order_info.payee_account}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="note">
              <el-input v-model="processForm.note"
                        placeholder="请输入备注信息（最多输入120个字符）"
                        maxlength="120"
                        clearable
                        type="textarea"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
        <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
        <button @click="validateForm" v-if="dialogTitle == 'passAuditDialogTit'" class="butStyle passGBtn">审核通过</button>
        <button @click="validateForm" v-if="dialogTitle == 'refusalToLendDialogTit'"
                class="butStyle refuseOBtn">拒绝放款</button>
        <button @click="validateForm" v-if="dialogTitle == 'delayHandleDialogTit'"
                class="butStyle delayYBtn">延后处理</button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  import {
    getTotalCount,
    getRandomAppliedOrder,
    getWalletLogs,
    updateMallWalletOrder,
    handleWalletOrder
  } from '@/api/Busy/Finance/finance.js';
  // 弹窗数据
  const defaultPostForm = {
    note: null, // 备注信息
  }

  // 搜索表格的条件
  const searchConst = {
    // 其他请求参数
    // business_type: null,
    page: 1, //当前页码
    rows: 10, //每页条数
  }

  export default {
    name: "CashOutAuditIndex",
    data() {
      return {
        noOrder: false,
        //标题
        topTitle: {
          title: '财务审核',
          subTit: '提现审核',
          thirdTit: '',
        },
        wallet_order_info: {
          member_id: '',
          payee_account: '',
          code: '',
          fee: '',
          service_fee: '',
          payee_mobile_phone: '',
          check_result: true,
          balance_of_apply_time: '',
          payee_name: '',
          pay_type: '',
          order_type: "2"
        },
        count_data: {
          reject_total_count: 0,
          reject_total_fee: 0,
          delay_total_count: 0,
          pass_total_count: 0,
          pass_total_fee: 0,
          delay_total_fee: 0,
          pending_total_count: 0,
          pending_total_fee: 0,
        },
        // 显示“开始审核”按钮
        showStartBtn: true,
        // 表格搜索条件
        searchForm: Object.assign({}, searchConst),
        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,
        // 提现时刻余额校验通过(绿色)/拒绝(橙色),默认不通过，
        checkPass: false,

        // 弹窗数据
        processForm: Object.assign({}, defaultPostForm),
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        // 弹窗标题
        dialogMap: {
          passAuditDialogTit: '审核通过',
          refusalToLendDialogTit: '拒绝放款',
          delayHandleDialogTit: '延后处理'
        },
        dialogTitle: '',
        rules: {},
      }
    },
    components: {},
    beforeRouteEnter (to, from, next) {
      const unlockPassword = localStorage.getItem('TemporaryPassword')
      if (unlockPassword) {
        next({path: '/busy/finance/temporaryPassword'})
      } else {
        next()
      }
    },
    methods: {
      async checkHasOrder() {
        try {
          const resp = await getRandomAppliedOrder()
          if (!resp.body) {
            this.$msgSuccess(resp.header.message)
            this.noOrder = true
          }
        } catch (e) {
          console.log(e)
        }
      },
      // 点击“历史审核”按钮
      goHistoryAudit() {
        this.$router.push({
          path: '/busy/finance/historyAudit',
          query: {}
        })
      },

      // 点击“离开一下”按钮
      leaveATime() {
        this.$router.push({
          path: '/busy/finance/temporaryPassword',
          query: {}
        })
      },

      // 点击“开始审核”按钮
      showMore() {
        this.loadWalletOrder();
      },
      async loadWalletOrder() {
        try {
          const result = await getRandomAppliedOrder()
          if (!result.body) {
            this.$msgSuccess(result.header.message)
            this.noOrder = true
            // this.wallet_order_info = null
            this.showStartBtn = true
            return;
          }
          this.noOrder = false
          this.showStartBtn = false
          this.wallet_order_info = result.body
          // 拿到工单创建人id再获取他的流水明细
          const wallet_logs_result = await getWalletLogs({member_id: this.wallet_order_info.member_id})
          this.tableData = wallet_logs_result.body.rows
          this.total = parseInt(wallet_logs_result.body.total)
        } catch (e) {
          console.log(e)
          // this.$message.error(e.message)
          // this.tableData = null
          // this.wallet_order_info = null
          // this.showStartBtn = true
        }
      },

      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.rows = val
        // 获取表格数据
        // this.initDataReportDetail()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.page = val
        // 获取表格数据
        // this.initDataReportDetail()
      },

      // 弹出手工添加“审核通过”窗口
      showPassAuditDialog() {
        this.dialogTitle = 'passAuditDialogTit'
        this.dialogFormVisible = true
      },
      // 弹出编辑“拒绝放款”窗口
      showRefusalToLendDialog(data) {
        this.dialogTitle = 'refusalToLendDialogTit'
        this.dialogFormVisible = true
      },
      // 弹出编辑“延后处理”窗口
      showDelayHandleDialog(data) {
        this.dialogTitle = 'delayHandleDialogTit'
        this.dialogFormVisible = true
      },

      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },
      // 关闭弹窗
      closeDialog() {
        this.resetData()
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.processForm = Object.assign({}, defaultPostForm)
      },

      // 验证表单-点击弹窗的“确定”按钮
      validateForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitForm()
          } else {
            this.dialogFormVisible = true
          }
        })
      },
      // 提交表单
      async submitForm() {
        const params = {
          wallet_order_id: this.wallet_order_info.wallet_order_id,
          accept_note: this.processForm.note
        }
        let message = '';
        if (this.dialogTitle === 'passAuditDialogTit') {
          message = '审核通过成功'
          params.process_type = 1
        } else if (this.dialogTitle === 'refusalToLendDialogTit') {
          message = '拒绝放款成功'
          params.process_type = 2
        } else if (this.dialogTitle === 'delayHandleDialogTit') {
          message = '延后处理成功'
          params.process_type = 3
        }
        try {
          const result = await handleWalletOrder(params)
          // 刷新工单
          this.loadWalletOrder()
          this.initCountData()
          this.closeDialog()
          this.$message.success(message)
        } catch (e) {
          console.log(e)
          // 2代表工单已被处理，重新获取一张新的工单
          if (e.header.code == 2) {
            this.loadWalletOrder();
            this.closeDialog()
          }
        }
      },
      initCountData() {
        getTotalCount()
            .then(resp => {
              this.count_data = resp.body
            })
      }
    },
    created() {
      this.initCountData()
      this.checkHasOrder()
    }

  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /* 文字顔色 */
  /* 浅绿 */
  .blackText {
    color: #4E4A46;
  }

  .lightGText {
    color: #76C819;
  }

  .orangeText {
    color: #FA6241;
  }

  .grayText {
    color: #7F7F7F;
  }

  .cashOutAudit {
    min-width: 1080px;
  }

  // 标题
  .cashOutAudit .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleBox b {
    color: #2B2727;
    font-size: 15px;
  }

  .titleBox span {
    color: #7F7F7F;
    font-size: 13px;
  }

  .titleBox .titRiImg {
    width: 76px;
    height: 24px;
    cursor: pointer;
  }

  // 四大审核信息+按钮
  .cashOutAudit .auditInfo {
    margin-top: 10px;
    height: 111px;
  }

  .auditInfo li {
    float: left;
    height: 111px;
    background: #fff;
  }

  .auditInfo li + li {
    margin-left: 12px;
  }

  .auditInfo li.infoLi {
    min-width: 220px;
    width: 16%;
    width: calc((100% - 148px - 48px) / 4);

    padding: 12px;
    display: flex;
    flex-flow: column nowrap;
  }

  .auditInfo li.infoLi .info_tit {
    height: 16px;
    line-height: 16px;
    display: flex;
    flex-flow: row nowrap;
  }

  .auditInfo li.infoLi .info_tit img {
    width: 16px;
    height: 16px;
  }

  .auditInfo li.infoLi .info_tit span {
    color: #34333A;
    font-size: 12px;
    margin-left: 4px;
  }

  .auditInfo li.infoLi .info_money {
    height: 42px;
    line-height: 42px;
    margin-top: 6px;
    font-size: 32px;
  }

  .auditInfo li.infoLi .info_count {
    height: 20px;
    line-height: 20px;
    margin-top: 3px;
    color: #AAAAAA;
    font-size: 12px;
    display: flex;
    flex-flow: row nowrap;
  }

  .auditInfo li.infoLi .info_count span {
    color: #333333;
    font-size: 15px;
    margin-left: 2px;
  }

  // 开始审核按钮
  .auditInfo li.lastStartBtn {
    float: left;
    width: 148px;
    height: 111px;
    background: none;
    cursor: pointer;
  }

  .auditInfo li.lastStartBtn img {
    width: 100%;
    height: 100%;
  }

  // 离开一下按钮
  .auditInfo li.lastLeaveBtn {
    float: left;
    width: 148px;
    height: 111px;
    background: #fff;
    cursor: pointer;
    border: 1px soild #EEEEEE;
    border-radius: 11px;
    -moz-border-radius: 11px;
    -webkit-border-radius: 11px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    text-align: center;
  }

  .auditInfo li.lastLeaveBtn img {
    width: 31px;
    height: 37px;
    margin-top: 22px;
  }

  .auditInfo li.lastLeaveBtn p {
    margin-top: 7px;
    color: #7F7F7F;
    font-size: 16px;
  }

  // 主要内容
  .cashOutAudit .mainBox {
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  // 主要内容-左边
  .mainBox .le_main {
    width: calc(100% - 312px - 15px);
    min-width: 749px;
  }

  // 左边-上提现信息
  .mainBox .le_main .topPayInfo {
    width: 100%;
    height: 300px;
    display: flex;
    flex-flow: column nowrap;
  }

  .topPayInfo .firstLine {
    width: 100%;
    height: 48px;
    padding: 0 12px;
    background: #FA6241;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  .topPayInfo .firstLine .first_le {
    font-size: 15px;
    font-weight: bold;
  }

  .topPayInfo .firstLine .first_ri {
    font-size: 12px;
    font-weight: bold;
  }

  .topPayInfo .firstLine .first_ri b {
    font-size: 12px;
  }

  .topPayInfo .secondLine {
    width: 100%;
    height: 28px;
    background: #EC502E;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
  }

  .topPayInfo .secondLine .second_le {
    // width: calc( (100% - 12px) / 2 );
    width: 50%;
    padding-left: 12px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-size: 12px;
    font-weight: bold;
  }

  .topPayInfo .secondLine .second_ri {
    margin-left: 12px;
    // width: calc( (100% - 12px) / 2 );
    width: 50%;
    padding-left: 12px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-size: 12px;
    font-weight: bold;
  }

  .topPayInfo .thirdBlock {
    width: 100%;
    height: 224px;
    background-color: #ffffff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    border-top: none;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  .thirdBlock .third_le {
    // width: calc( (100% - 12px) / 2 );
    width: 50%;
    // height: 224px;
    padding: 0 12px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-size: 12px;
    background: #FFFFFF;
    border-right: 1px solid #EEEEEE;
  }

  .thirdBlock .third_ri {
    margin-left: 12px;
    // width: calc( (100% - 12px) / 2 );
    width: 50%;
    // height: 224px;
    padding: 0 12px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-size: 12px;
    background: #FFFFFF;
    border-left: 1px solid #EEEEEE;
  }

.thirdBlock .third_le .thirdLine,
.thirdBlock .third_ri .thirdLine {
  width: 100%;
  height: 36px;
  line-height: 36px;
  box-shadow: 0px 1px 0px #EEEEEE;
	-moz-box-shadow: 0px 1px 0px #EEEEEE;
	-webkit-box-shadow: 0px 1px 0px #EEEEEE;
}
.thirdBlock .third_le .thirdLine .line_tit,
.thirdBlock .third_ri .thirdLine .line_tit {
  width:52px;
  float:left;
  font-size:13px;
  font-weight:bold;
  color:#AAAAAA;
}
.thirdBlock .third_le .thirdLine .line_msg,
.thirdBlock .third_ri .thirdLine .line_msg {
  width:calc( 100% - 52px - 20px);
  margin-left: 20px;
  font-size:13px;
  color:#333333;
}
.thirdBlock .third_le .thirdLine .line_msg4{
  width:calc( 100% - 52px - 20px);
  margin-left: 20px;
  font-size:13px;
  color:#76C819;
}

  .thirdBlock .third_le .botLine,
  .thirdBlock .third_ri .botLine {
    width: 100%;
    height: 72px;
    line-height: 72px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
  }

  .thirdBlock .third_le .botLine .bot_tit,
  .thirdBlock .third_ri .botLine .bot_tit {
    width: 120px;
    font-size: 13px;
    font-weight: bold;
    color: #AAAAAA;
  }

  .thirdBlock .third_le .botLine .bot_msg{
    font-size: 32px;
    color: #2B2727;
  }
  .thirdBlock .third_ri .botLine .bot_msg {
    font-size: 32px;
    color: #FA6241;
  }

  // 左边-下表格
  .mainBox .le_main .botTable {
    margin-top: 17px;
    width: 100%;
    // max-height: 750px;
  }

  .botTable .tableTop {
    height: 44px;
    padding: 0 11px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .top_ri {
    font-size: 12px;
    color: #4E4A46;
  }

  .botTable .tableTop .top_ri b {
    font-size: 20px;
    font-weight: normal;
    color: #FA6241;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    // border-bottom-left-radius: 3px;
    // border-bottom-right-radius: 3px;
  }

  // 主要内容-右边
  .mainBox .ri_main {
    width: 312px;
    height: 440px;
    margin-left: 15px;
    // padding: 12px 12px 46px;
    padding: 12px 12px 0;
    background: #ffffff;
  }

  .mainBox .ri_main img.passImg {
    // width: 100%;
    width: 288px;
    height: 112px;
    cursor: pointer;
  }

  .mainBox .ri_main .msgBox {
    width: 222px;
    height: 50px;
    margin: 24px auto 0;
    border: 1px dashed #76C819;
    color: #76C819;
    border-radius: 9px;
    -moz-border-radius: 9px;
    -webkit-border-radius: 9px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

  }

  .mainBox .ri_main .msgBox.greenMsg {

  }

  .mainBox .ri_main .msgBox.redMsg {
    color: #FA6241;
    border: 1px dashed #FA6241;
  }

  .mainBox .ri_main .msgBox .leftImg {
    width: 32px;
    height: 32px;
    margin: 0 8px 0 12px;
  }

  .mainBox .ri_main .msgBox .riMsg {

    font-size: 15px;
    font-weight: blod;
  }

  .mainBox .ri_main .tip1 {
    height: 16px;
    line-height: 16px;
    margin-top: 36px;
    font-size: 12px;
    font-weight: bold;
    color: #999999;
  }

  .mainBox .ri_main .tip2 {
    height: 16px;
    line-height: 16px;
    margin-top: 0;
    font-size: 12px;
    font-weight: bold;
    color: #999999;
  }

  .mainBox .ri_main .tip3 {
    height: 16px;
    line-height: 16px;
    margin-top: 12px;
    font-size: 12px;
    font-weight: bold;
    color: #999999;
  }

  .mainBox .ri_main .tip4 {
    height: 16px;
    line-height: 16px;
    margin-top: 0;
    font-size: 12px;
    font-weight: bold;
    color: #999999;
  }

  .mainBox .ri_main .tip1 span,
  .mainBox .ri_main .tip2 span {
    color: #333333;
    font-weight: normal;
  }

  .mainBox .ri_main .tip3 span,
  .mainBox .ri_main .tip4 span {
    color: #333333;
  }

  .mainBox .ri_main .botBtnLine {
    margin-top: 24px;
  }

  .mainBox .ri_main .botBtnLine .botLeImg {
    width: 140px;
    height: 60px;
    cursor: pointer;
  }

  .mainBox .ri_main .botBtnLine .botRiImg {
    width: 140px;
    height: 60px;
    margin-left: 8px;
    cursor: pointer;
  }



  // 没有可审核的单
.noOrder{
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 127px 0;
}
.noOrder img {
  width: 160px;
  height: 160px;
}
.noOrder p {
  height: 20px;
  line-height: 35px;
  color: #7F7F7F;
  font-size: 15px;
  font-weight: bold;
}

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-绿色按钮
  .passGBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #2DBAA5;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(134, 189, 180)
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  // 弹窗按钮-黄色按钮
  .delayYBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #F99A1A;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(248, 186, 105);
    }
  }

</style>
